import { render, staticRenderFns } from "./AddSortConditionBasedOnField.vue?vue&type=template&id=0117bee2"
import script from "./AddSortConditionBasedOnField.vue?vue&type=script&lang=ts"
export * from "./AddSortConditionBasedOnField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports